import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Matcher from "@/pages/Matcher";
import GrainOverlay from "@/components/matcher/GrainOverlay";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <GrainOverlay />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Matcher />} />
          <Route path="/match/:id" element={<Matcher />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#141412",
            color: "#E3DAC9",
            border: "1px solid #2A2A28",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
